import React, { useEffect, useState } from "react";
import SideBar from "../SideBar";
import Navbar from "../Navbar";
import axiosClient from "../../../axios-client";
import { useNavigate } from "react-router-dom";
const PendingSubscribers = () => {
  const [pendingSubscribers, setPendingSubscribers] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modalData, setModalData] = useState(null);
  const navigate = useNavigate();
  const [isSuccessModalOpen, setIsSuccessModalOpen] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");

  const fetchPendingSubscribers = async () => {
    try {
      const response = await axiosClient.get("/subscriptions/check-pending");
      setPendingSubscribers(response.data);
    } catch (error) {
      console.error("Error fetching pending subscribers:", error);
    }
  };

  useEffect(() => {
    fetchPendingSubscribers();
  }, []);
  useEffect(() => {
    const adminToken = localStorage.getItem("Admin_Token");
    if (!adminToken) {
      navigate("/admin/login");
    }
  }, [navigate]);

  const handleViewDetails = (subscriber) => {
    // Set the modal data with the plan details
    setModalData({
      type: "details",
      subscriber,
    });
    setIsModalOpen(true);
  };
  const handleDelete = (subscriptionId) => {
    // Set the modal data for delete confirmation
    console.log(subscriptionId);
    setModalData({
      type: "delete",
      subscriptionId,
    });
    setIsModalOpen(true);
  };

  const confirmDelete = async (subscriptionId) => {
    try {
      await axiosClient.delete("subscriptions/delete-requested-plan", {
        data: { subscriptionId },
      });
      console.log("Plan deleted successfully");
      // Optionally, you can refresh the list of pending subscribers here
      fetchPendingSubscribers();

      closeModal();
    } catch (error) {
      console.error("Error deleting plan:", error);
    }
  };

  const handleActivate = (subscriptionId) => {
    console.log(subscriptionId);
    // Set the modal data for activate confirmation
    setModalData({
      type: "activate",
      subscriptionId,
    });
    setIsModalOpen(true);
  };

  const confirmActivate = async (subscriptionId) => {
    try {
      const response = await axiosClient.post("subscriptions/activate-plan", {
        subscriptionId,
      });

      console.log("Plan activated successfully");
      // Optionally, you can refresh the list of pending subscribers here
      if (response.status === 200) {
        setSuccessMessage("Plan activated successfully");
        setIsSuccessModalOpen(true);
        fetchPendingSubscribers(); // Refresh the list of pending subscribers
      }
      closeModal();
    } catch (error) {
      console.error("Error activating plan:", error);
    }
  };

  const closeModal = () => {
    setIsModalOpen(false);
    setModalData(null);
  };
  const closeSuccessModal = () => {
    setIsSuccessModalOpen(false);
    setSuccessMessage("");
  };
  console.log(pendingSubscribers, "pendingSubscribers");
  return (
    <>
      <SideBar />
      <Navbar />
      <div className="p-8" style={{ paddingLeft: "17rem" }}>
        <h1 className="text-2xl font-bold mb-6">Pending Request User Plan</h1>
        {pendingSubscribers.length === 0 ? (
          <p>No Pending Subscribers</p>
        ) : (
          <table className="min-w-full bg-white border border-gray-200">
            <thead>
              <tr>
                <th className="py-2 px-4 border-b border-gray-200 text-left">
                  S No.
                </th>

                <th className="py-2 px-4 border-b border-gray-200 text-left">
                  User Name
                </th>
                <th className="py-2 px-4 border-b border-gray-200 text-left">
                  Plan Name
                </th>
                <th className="py-2 px-4 border-b border-gray-200 text-left">
                  Status
                </th>
                <th className="py-2 px-4 border-b border-gray-200 text-left">
                  Action
                </th>
              </tr>
            </thead>
            <tbody>
              {pendingSubscribers?.map((subscriber, index) => (
                <tr key={subscriber.userId}>
                  <td className="py-2 px-4 border-b border-gray-200">
                    {index + 1}
                  </td>

                  <td className="py-2 px-4 border-b border-gray-200">
                    {subscriber?.user && subscriber?.user.name}
                  </td>
                  <td className="py-2 px-4 border-b border-gray-200">
                    {subscriber?.plan && subscriber?.plan.name}
                  </td>
                  <td className="py-2 px-4 border-b border-gray-200">
                    {subscriber?.status && subscriber?.plan?.status}
                  </td>
                  <td className="py-2 px-4 border-b border-gray-200">
                    <button
                      onClick={() => handleViewDetails(subscriber)}
                      className="bg-blue-500 text-white px-4 py-2 rounded  mr-4"
                    >
                      View Details
                    </button>
                    <button
                      onClick={() => handleDelete(subscriber._id)}
                      className="bg-red-500 text-white px-4 py-2 rounded mr-4"
                    >
                      Delete
                    </button>
                    <button
                      onClick={() => handleActivate(subscriber._id)}
                      className="bg-green-500 text-white px-4 py-2 rounded "
                    >
                      Activate Plan
                    </button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        )}
      </div>
      {isModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded shadow-lg w-3/4 max-w-4xl">
            {modalData.type === "details" && (
              <div>
                <h2 className="text-2xl font-bold mb-4">Plan Details</h2>
                <div className="mb-4">
                  <p className="text-lg">
                    <strong>User Name:</strong>{" "}
                    {modalData?.subscriber?.user?.name}
                  </p>
                  <p className="text-lg">
                    <strong>Plan Name:</strong>{" "}
                    {modalData?.subscriber?.plan?.name}
                  </p>
                  <p className="text-lg">
                    <strong>Status:</strong> {modalData?.subscriber?.status}
                  </p>
                </div>
                <div>
                  <h3 className="text-xl font-semibold mb-2">Plan Features:</h3>
                  <ul className="list-disc list-inside">
                    {Object.keys(modalData?.subscriber?.plan?.features).map(
                      (key, index) => (
                        <li key={index} className="mb-1">
                          <strong>{key}:</strong>{" "}
                          {modalData?.subscriber?.plan?.features[
                            key
                          ].toString()}
                        </li>
                      )
                    )}
                  </ul>
                </div>
              </div>
            )}
            {modalData.type === "delete" && (
              <div>
                <p>
                  Are you sure you want to delete plan:{" "}
                  {modalData.subscriptionId}?
                </p>
                <button
                  onClick={() => confirmDelete(modalData.subscriptionId)}
                  className="bg-red-500 text-white px-4 py-2 rounded"
                >
                  Confirm Delete
                </button>
              </div>
            )}
            {modalData.type === "activate" && (
              <div>
                <p>
                  Are you sure you want to activate plan:{" "}
                  {modalData.subscriptionId}?
                </p>
                <button
                  onClick={() => confirmActivate(modalData.subscriptionId)}
                  className="bg-green-500 text-white px-4 py-2 rounded"
                >
                  Confirm Activate
                </button>
              </div>
            )}

            <div className="mt-4">
              <button
                onClick={closeModal}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}

      {isSuccessModalOpen && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
          <div className="bg-white p-8 rounded-lg shadow-lg w-3/4 max-w-4xl">
            <h2 className="text-2xl font-bold mb-4">Success</h2>
            <p>{successMessage}</p>
            <div className="mt-4">
              <button
                onClick={closeSuccessModal}
                className="bg-gray-500 text-white px-4 py-2 rounded mr-2"
              >
                Close
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};
export default PendingSubscribers;
